<template>
  <AppLayout>
    <div class="container mt-4">
      <div class="col-12 row d-flex align-items-stretch">
        <div class="col-md-12 col-lg-10 d-flex align-items-stretch mb-3">
          <Link :href="route('bhp.terminy.ubran')" class="btn btn-outline-primary">
            <i class="bi bi-list"></i>&nbsp;Powrót do listy
          </Link>
        </div>

        <div class="col-md-6 mb-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body d-flex flex-column justify-content-start">
              <h5 class="card-title">Dane pracownika</h5>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Imię:</label>
                  <div class="form-control">{{ lokalneImie }} &nbsp;</div>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Nazwisko:</label>
                  <div class="form-control">{{ lokalneNazwisko }} &nbsp;</div>
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label">Telefon firmowy:</label>
                  <div class="form-control">{{ lokalneTelFir }} &nbsp;</div>
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label">E-mail firmowy:</label>
                  <div class="form-control">{{ lokalneEmFir }} &nbsp;</div>
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label">Oddział:</label>
                  <div class="form-control">{{ oddzial }} &nbsp;</div>
                </div>
                <div class="col-md-12 mb-3">
                  <label class="form-label">Stanowisko:</label>
                  <div class="form-control">{{ lokalnestanowisko }} &nbsp;</div>
                </div>
                <div class="col-md-12 mb-3">
                  <label class="form-label">Dział:</label>
                  <div class="form-control">{{ departament_name }} &nbsp;</div>
                </div>
              </div>
            </div>
          </div>
        </div>


<!-- Aktywne artykuły -->
<div class="col-md-6 mb-4">
  <div class="card h-100 shadow-sm">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="card-title">Ubrania / ochrona osobista</h5>
        <button class="btn btn-sm btn-success" @click="openAddModal">
          <i class="bi bi-plus-circle me-2"></i> Dodaj
        </button>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered table-hover text-center">
          <thead>
          <tr>
            <th>Nazwa</th>
            <th>Grupa</th>
            <th>Rozmiar</th>
            <th>Data wydania</th>
            <th>Wymiana</th>
            <th>Archiwum</th>
            <th>Opcje</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="art in userArtykuly.filter(a => a.archived === 0)" :key="art.id">
            <td class="text-start">{{ artykuly[art.artykul_id]?.nazwa || '-' }}</td>
            <td class="text-center">{{ grupy.find(g => g.id === art.grupa_id)?.nazwa || '-' }}</td>
            <td class="text-center">{{ rozmiary[art.rozmiar_id] || '-' }}</td>
            <td class="text-end">
              <div v-if="editingArt && editingArt.id === art.id">
                <input type="date" v-model="editedDate" class="form-control form-control-sm"/>
                <div class="mt-1">
                  <button class="btn btn-sm btn-primary me-1" @click="saveDate(art)">✔</button>
                  <button class="btn btn-sm btn-danger" @click="cancelEdit">✖</button>
                </div>
              </div>
              <div v-else>
                {{ formatDate(art.data_wydania) }}
                <button class="btn btn-sm btn-outline-info ms-1" @click="startEdit(art)"><i class="bi bi-pencil"></i></button>
              </div>
            </td>
            <td class="text-center"
                :style="{
                  backgroundColor: art.nochange == 0 && dniDoWymiany(art.data_wydania, artykuly[art.artykul_id]?.wymiana).dni !== null && dniDoWymiany(art.data_wydania, artykuly[art.artykul_id]?.wymiana).dni < 60 ? 'red' : '',
                  color: art.nochange == 0 && dniDoWymiany(art.data_wydania, artykuly[art.artykul_id]?.wymiana).dni !== null && dniDoWymiany(art.data_wydania, artykuly[art.artykul_id]?.wymiana).dni < 60 ? 'white' : ''
                }"
                v-html="art.nochange == 0 && dniDoWymiany(art.data_wydania, artykuly[art.artykul_id]?.wymiana).dni !== null ? dniDoWymiany(art.data_wydania, artykuly[art.artykul_id]?.wymiana).dni + ' dni ' + dniDoWymiany(art.data_wydania, artykuly[art.artykul_id]?.wymiana).ikona : ''">
            </td>
            <td class="text-center">
              <select class="form-select form-select-xs" v-model.number="art.archived" @change="updateArch(art)" :style="{ color: art.archived == 0 ? 'green' : 'red', fontWeight: 'bold' }">
                <option :value="0" :style="{ color:'red', fontWeight: 'bold' }">✖ Nie</option>
                <option :value="1" :style="{ color: 'green', fontWeight: 'bold' }">✔ Tak</option>
              </select>
            </td>
            <td class="text-center">
              <button class="btn btn-sm btn-outline-danger" @click="deleteItem(art.id)">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Archiwum -->
<div class="col-md-6 mb-4">
  <div class="card h-100 shadow-sm">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="card-title">Archiwum</h5>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered table-hover text-center">
          <thead>
          <tr>
            <th>Nazwa</th>
            <th>Grupa</th>
            <th>Rozmiar</th>
            <th>Data wydania</th>
            <th>Archiwum</th>
            <th>Opcje</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="art in userArtykuly.filter(a => a.archived === 1)" :key="art.id">
            <td class="text-start">{{ artykuly[art.artykul_id]?.nazwa || '-' }}</td>
            <td class="text-center">{{ grupy.find(g => g.id === art.grupa_id)?.nazwa || '-' }}</td>
            <td class="text-center">{{ rozmiary[art.rozmiar_id] || '-' }}</td>
            <td>{{ formatDate(art.data_wydania) }}</td>
            <td class="text-center">
              <select class="form-select form-select-xs" v-model.number="art.archived" @change="updateArch(art)" :style="{ color: art.archived == 0 ? 'green' : 'red', fontWeight: 'bold' }">
                <option :value="0" :style="{ color:'red', fontWeight: 'bold' }">✖ Nie</option>
                <option :value="1" :style="{ color: 'green', fontWeight: 'bold' }">✔ Tak</option>
              </select>
            </td>
            <td class="text-center">
              <button class="btn btn-sm btn-outline-danger" @click="deleteItem(art.id)">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


        <div class="col-md-6 mb-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body">
              <div class="h-100">
                <h5 class="card-title">Pliki</h5>

                <div class="row">
                  <ul class="list-group ps-3 me-3 mt-3 mb-3">
                    <li
                        class="list-group-item d-flex align-items-center justify-content-between flex-wrap fw-bold bg-light"
                        v-if="localFiles.length > 0"
                    >
                      <div class="col-12 col-sm-6 col-md-5 text-truncate">Nazwa pliku</div>
                      <div class="col-12 col-sm-4 col-md-4">Data utworzenia</div>
                      <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">Opcje</div>
                    </li>
                    <li v-if="isLoadingFiles" class="list-group-item border-0">
                      <div class="spinner-border spinner-border-reverse align-self-center loader-sm text-secondary">
                        Ładowanie...
                      </div>
                    </li>

                    <li class="list-group-item d-flex align-items-center justify-content-between flex-wrap" v-else
                        v-for="file in localFiles" :key="file.id">
                      <div class="col-12 col-sm-6 col-md-5 text-truncate" :title="file.name">
                        {{ file.name }}
                      </div>
                      <div class="col-12 col-sm-4 col-md-4 text-muted small">
                        <i>{{ file.created_at }}</i>
                      </div>
                      <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">
                        <div class="d-flex justify-content-end flex-wrap gap-1">
                          <a class="btn btn-sm btn-outline-info" style="width:80px;"
                             :href="route('bhp.download-file', [this.userID, file.name])"
                             download>
                            <i class="bi bi-download me-1"></i>Pobierz
                          </a>
                          <button class="btn btn-sm btn-outline-danger" style="width:80px;" @click="deleteFile(file)"
                                  type="button">
                            <i class="bi bi-trash me-1"></i>Usuń
                          </button>
                        </div>
                      </div>
                    </li>

                    <!-- Brak plików -->
                    <li class="list-group-item" v-if="localFiles.length <= 0 && !isLoadingFiles">
                      <i>Brak plików</i>
                    </li>
                  </ul>
                </div>

                <form @submit.prevent="submitForm">
                  <div class="row gap-3">
                    <div class="col-12">
                      <label for="attachments">Dodaj pliki:</label>
                      <div v-if="isLoading" class="mt-3">
                        <div class="progress" style="height: 8px;">
                          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                               :style="{ width: uploadProgress + '%' }"></div>
                        </div>
                        <small class="text-muted">{{ uploadProgress }}%</small>
                      </div>
                      <input type="file" id="attachments" multiple @change="handleFileUpload"
                             class="form-control form-control-sm" ref="fileInput"/>
                      <div v-if="form.attachments.length">
                        <p class="mt-2">Załączone pliki:</p>
                        <ul class="list-group">
                          <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap"
                              v-for="(file, index) in form.attachments" :key="index">
                            <span class="text-truncate" :title="file.name">{{ file.name }}</span>
                            <button type="button" class="btn btn-sm btn-danger ms-2 mt-1 mt-sm-0"
                                    @click="removeFile(index)">Usuń
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div v-if="form.attachments.length">
                        <button type="submit" class="btn btn-primary mt-3" :disabled="isLoading">
                          {{ isLoading ? 'Wysyłanie...' : 'Dodaj pliki' }}
                        </button>
                      </div>

                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>


        <!-- Modal dodawania ubran -->
        <div v-if="showAddModal" class="modal fade show d-block" style="background: rgba(0,0,0,.5);">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Dodaj artykuł</h5>
                <button type="button" class="btn-close" @click="closeAddModal"></button>
              </div>
              <div class="modal-body">
                <div class="mb-2">
                  <label>Grupa</label>
                  <select v-model="newItem.grupa_id" @change="fetchArtykuly" class="form-select">
                    <option value="">-- wybierz grupę --</option>
                    <option v-for="g in grupy" :value="g.id">{{ g.nazwa }}</option>
                  </select>
                </div>
                <div v-if="availableArtykuly.length > 0" class="mb-2">
                  <label>Artykuł</label>
                  <select v-model="newItem.artykul_id" class="form-select" @change="selectRozmiary">
                    <option value="">-- wybierz artykuł --</option>
                    <option v-for="a in availableArtykuly" :value="a.id">{{ a.nazwa }}</option>
                  </select>
                </div>
                <div v-if="availableRozmiary.length > 0" class="mb-2">
                  <label>Rozmiar</label>
                  <select v-model="newItem.rozmiar_id" class="form-select">
                    <option value="">-- wybierz rozmiar --</option>
                    <option v-for="r in availableRozmiary" :value="r.id" :disabled="r.disabled">{{ r.nazwa }} ({{
                        r.stan
                      }})
                    </option>
                  </select>
                </div>
                <div class="mb-2">
                  <label>Data wydania</label>
                  <input type="date" v-model="newItem.data_wydania" class="form-control"/>
                </div>
				<div class="mb-2">
				  <label>Czy Bezterminowo?</label>
				  <select v-model.number="newItem.wymiana" class="form-select">
					<option :value="0">Nie</option>
					<option :value="1">Tak</option>
				  </select>
				</div>
			  </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" @click="closeAddModal">Anuluj</button>
                <button class="btn btn-primary" @click="addItem">Zapisz</button>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {router} from "@inertiajs/vue3";
import axios from "axios";

export default {
  props: {
    userID: Number,
    userImie: String,
    userNazwisko: String,
    userPhoneFir: String,
    userEmailFir: String,
    departament: String,
    departament_name: String,
    oddzial: String,
    grupy: Array,
    rozmiary: Array,
    artykuly: Array,
    pliki: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {AppLayout},
  data() {
    return {
      initAttachments: [],
      form: {
        name: null,
        attachments: [],
        errors: {}
      },
      localFiles: [...this.pliki],
      isLoadingFiles: true,
      isLoading: false,
      isProcessing: false,
      uploadProgress: 0,
      uploadError: null,
      uploadSuccess: false,
		selectedArtykul: null,
      lokalneImie: this.userImie ?? '',
      lokalneNazwisko: this.userNazwisko ?? '',
      lokalnestanowisko: this.departament ?? '',
      lokalneTelFir: this.userPhoneFir ?? '',
      lokalneEmFir: this.userEmailFir ?? '',
      userArtykuly: [],
      editingArt: null,
      editedDate: '',
      showAddModal: false,
newItem: {
  grupa_id: '',
  artykul_id: '',
  rozmiar_id: '',
  data_wydania: new Date().toISOString().slice(0, 10),
  wymiana: 0 // domyślnie Nie
},
      availableArtykuly: [],
      availableRozmiary: [],
    };
  },
  async mounted() {
    await this.loadData(); // jeśli chcesz, żeby czekało na loadData
    this.initAttachments = await this.getAttachments();
    this.matchFiles();
    this.isLoadingFiles = false;
  },
  methods: {
              async updateArch(artykul) {
                try {
                    await axios.post(`/bhp/pracownik/ubrania/archived/${artykul.id}`, {
                        archived: artykul.archived
                    });
				    this.loadData();
                    this.showToast('success', 'Uwaga!', 'Status archiwum artykułu został zmieniony.');
                } catch (error) {
                    alert("Nie udało się zmienić statusu archiwum artykulu.");
                }
            },
			
    async deleteFile(file) {
      let self = this;

      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie pliku',
        html: 'Czy na pewno chcesz usunąć ten plik?',
        showDenyButton: true,
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(route('bhp.file.delete', {
              user_id: self.userID,
              attachment: file.id
            }));

            if (response.data.icon === 'success') {
              self.showToast('success', 'Usunięto plik', 'Plik został pomyślnie usunięty.');
              await self.refreshAttachments(); // odśwież listę plików
            } else {
              self.showToast('error', response.data.title, response.data.message);
            }

          } catch (error) {
            console.error("Błąd usuwania pliku:", error);
            self.showToast('error', 'Błąd', 'Nie udało się usunąć pliku.');
          }
        }
      });
    },


    async getAttachments() {
      const user_id = this.userID;
      try {
        const response = await axios.post(route('bhp.ubrania.get.userfiles', {user_id: user_id}));
        return response.data.attachments ?? [];
      } catch (error) {
        console.log(error);
        return [];
      }
    },

    handleFileUpload(event) {
      this.uploadError = null;
      const files = Array.from(event.target.files);

      const maxSize = 100 * 1024 * 1024; // 100 MB
      const validFiles = [];

      for (let file of files) {
        if (file.size > maxSize) {
          this.uploadError = `Plik "${file.name}" jest za duży (max 100 MB).`;
        } else if (file.size === 0) {
          this.uploadError = `Plik "${file.name}" jest pusty.`;
        } else {
          validFiles.push(file);
        }
      }

      if (validFiles.length > 0) {
        this.form.attachments.push(...validFiles);
      }

      this.$refs.fileInput.value = "";
    },

    removeFile(index) {
      this.form.attachments.splice(index, 1);
    },

    matchFiles() {
      try {
        if (this.initAttachments.length > 0) {
          this.localFiles = [...this.initAttachments];
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingFiles = false;
      }
    },

    async refreshAttachments() {
      this.isLoadingFiles = true;
      try {
        const attachments = await this.getAttachments();
        this.localFiles = attachments;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingFiles = false;
      }
    },

    async submitForm() {
      this.form.errors = {};
      this.uploadError = null;
      this.uploadProgress = 0;
      this.isProcessing = true;

      if (this.form.attachments.length === 0) {
        this.uploadError = "Nie wybrano plików do wysłania.";
        this.isProcessing = false;
        return;
      }

      this.isLoading = true;
      let formData = new FormData();
      this.form.attachments.forEach((file) => {
        formData.append('attachments[]', file);
      });

      const user_id = this.userID;

      try {
        const response = await axios.post(route('bhp.ubrania.add.file', {user_id}), formData, {
          headers: {'Content-Type': 'multipart/form-data'},
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            }
          }
        });

        // po sukcesie
        this.form.attachments = [];
        await this.refreshAttachments();
        this.$refs.fileInput.value = "";
        this.uploadProgress = 100;

      } catch (error) {
        console.error("Błąd zapisu:", error);
        this.uploadError = error.response?.data?.message || "Wystąpił błąd podczas wysyłania pliku.";
      } finally {
        this.isProcessing = false;
        this.isLoading = false;

        setTimeout(() => this.uploadProgress = 0, 3000);
      }
    },

  
  
  
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("pl-PL");
      // zmiana daty dd.mm.yyyy
    },

    startEdit(art) {
      this.editingArt = art;
      this.editedDate = art.data_wydania;
    },
    cancelEdit() {
      this.editingArt = null;
      this.editedDate = '';
    },
    async saveDate(art) {
      try {
        await axios.put(`/bhp/ubrania/update/${art.id}`, {
          artykul_id: art.artykul_id,
          rozmiar_id: art.rozmiar_id,
          data_wydania: this.editedDate,
        });
        art.data_wydania = this.editedDate;
        this.cancelEdit();
        this.showToast('success', 'Sukces', 'Data wydania została zmieniona.');
      } catch (err) {
        this.showToast('error', 'Błąd', 'Błąd aktualizacji!');
      }
    },
    // Dodawanie
    openAddModal() {
      this.showAddModal = true;
      this.newItem = {
        grupa_id: '',
        artykul_id: '',
        rozmiar_id: '',
        data_wydania: new Date().toISOString().slice(0, 10),
		 wymiana: 0
      };
    },
    closeAddModal() {
      this.showAddModal = false;
    },
    async fetchArtykuly() {
      if (!this.newItem.grupa_id) return;
      const res = await axios.get(route("bhp.ubrania.pobierz-all"), {
        params: {user_id: this.userID, grupa_id: this.newItem.grupa_id}
      });
      this.availableArtykuly = res.data.artykuly;
      this.availableRozmiary = [];
    },
    selectRozmiary() {
      const art = this.availableArtykuly.find(a => a.id === this.newItem.artykul_id);
      this.availableRozmiary = art ? art.rozmiary : [];
	  this.selectedArtykul = art;
     this.newItem.wymiana = 0;
    },
    async addItem() {
      try {
        await axios.post(route("bhp.terminy.ubrania.store"), {
          user_id: this.userID,
          ...this.newItem,
        });
        this.closeAddModal();
        this.loadData();
        this.showToast('success', 'Sukces', 'Artykuł został dodany.');
      } catch (err) {
        this.showToast('error', 'Błąd', 'Nie udało się dodać artykułu!');
      }
    },
  
    async loadData() {
      try {
        const response = await axios.get(route("bhp.ubrania.pracownika"), {params: {userId: this.userID}});
        this.userArtykuly = response.data.userArtykuly || [];
      } catch (error) {
        console.error(error);
      }
    },
    dniDoWymiany(dataWydania, wymiana) {
      if (!dataWydania || !wymiana) return {dni: null, ikona: ''};
      const wydanieDate = new Date(dataWydania);
      const today = new Date();
      const nextExchangeYear = wydanieDate.getFullYear() + parseInt(wymiana);
      const nextExchangeDate = new Date(wydanieDate);
      nextExchangeDate.setFullYear(nextExchangeYear);
      const diffTime = nextExchangeDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      let ikona = '';
      if (diffDays < 0) ikona = '<span class="text-danger style="color:red;"  ms-1" title="Minął termin wydania odzieży">⚠️</span>';
      else if (diffDays < 30 && diffDays >= 0) ikona = '<span class="text-warning ms-1" title="Zbliża się termin wydania odzieży">⚠️</span>';
      return {dni: diffDays, ikona};
    },
    editDate(art) {
      this.editingArt = art;
      this.editedDate = art.data_wydania;
    },
    closeModal() {
      this.editingArt = null;
      this.editedDate = '';
    },

    async deleteItem(artId) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie artykułu',
        html: 'Czy na pewno chcesz usunąć wybrany artykuł?',
        input: 'checkbox',
        inputValue: 0,
        inputPlaceholder: 'Przywrócić na stan magazynowy',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios.delete(`/bhp/ubrania/delete/${artId}`, {
              data: {
                restore_stock: result.value === 1
              }
            });

            await this.loadData();
            this.showToast('success', 'Sukces', 'Artykuł został usunięty z listy.');
          } catch (error) {
            this.showToast('error', 'Błąd', 'Nie udało się usunąć artykułu!');
          }
        }
      });
    },
    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  },
};
</script>

<style scoped>
.card-title {
  font-weight: bold;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.list-group-item.bg-light > div {
  font-size: 0.9rem;
}
</style>
